module.exports = __webpack_public_path__ + "static/key-visual-background-8c6b53d2b9e9d0baa89ccf5268b5a23a.png";